import clsx from 'clsx'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { useResponsiveSize } from '../../../hooks/useResponsiveSize'
import { BOOK_BASE } from '../../../utils/constants'
import { Icon } from '../../Icon'
import Button from '../../app/design/Button'
import Card from '../../app/design/Card'
import Heading from '../../app/design/Heading'
import Paragraph from '../../app/design/Paragraph'
import { RequestCallPage } from '../RequestCallPage'

function GetStartedButtons() {
    const [requestCall, setRequestCall] = useState(false)

    if (requestCall) {
        return (
            <RequestCallPage
                forDashboard={false}
                isOpen={requestCall}
                onClose={() => setRequestCall(false)}
            />
        )
    }

    return (
        <div className="flex flex-col gap-4">
            <Button intent="primary" onClick={() => setRequestCall(true)}>
                Request an ASAP callback
            </Button>
            <Button
                intent="secondary"
                onClick={() =>
                    window.open(
                        `${BOOK_BASE}/book/pocketsuite/items/pocketsuite-academy-recordings `,
                        '_blank'
                    )
                }
            >
                Watch tutorials
            </Button>
        </div>
    )
}

function FinishingButtons() {
    return (
        <div className="flex flex-col gap-4">
            <Button
                intent="primary"
                onClick={() =>
                    window.open(
                        `${BOOK_BASE}/book/pocketsuite/items/pocketsuite-academy-recordings `,
                        '_blank'
                    )
                }
            >
                Watch tutorials
            </Button>
            <Button
                intent="secondary"
                onClick={() =>
                    window.open(`${BOOK_BASE}/book/pocketsuite/items/pocketsuite-academy`, '_blank')
                }
            >
                Schedule a call
            </Button>
        </div>
    )
}

export function AlertASAPPage() {
    const [searchParams] = useSearchParams()
    const finishing = searchParams.get('finishing')
    const { vh } = useResponsiveSize()

    return (
        <div
            className={clsx('bg-info-100 -m-1 mx-auto max-w-[648px] rounded-lg', {
                'absolute top-1/2 right-0 left-0 -translate-y-1/2': vh >= 850,
            })}
        >
            <div className="overflow-hidden">
                <img
                    src="/icons/message-card-work-call.svg"
                    className="mx-auto mt-8 -mb-8 h-[230px] w-[230px]"
                />
            </div>
            <div className="rounded-b-lg bg-white p-8 text-center">
                <Heading size="xl" className="text-gray-700">
                    We are here for you!
                </Heading>
                <Paragraph size="md" className="mt-4 text-gray-600">
                    Whether you have a simple workflow or advanced set-up needs. Connect with our
                    team to take full advantage of what PocketSuite offers.
                </Paragraph>
                <div className="my-10 flex flex-col gap-4 text-left">
                    <Heading size="xs" className="text-gray-700">
                        PocketSuite Offers:
                    </Heading>
                    <Paragraph size="md" className="flex items-center text-gray-600">
                        <Icon
                            icon="phone.large"
                            className="mr-4 text-gray-600"
                            shouldInheritColor
                        />
                        Begin with a live Welcome Call startup
                    </Paragraph>
                    <Paragraph size="md" className="flex items-center text-gray-600">
                        <Icon
                            icon="coins.large"
                            className="mr-4 text-gray-600"
                            shouldInheritColor
                        />
                        Book a live Foundations Call for a more in depth set-up
                    </Paragraph>
                    <Paragraph size="md" className="flex items-center text-gray-600">
                        <Icon
                            icon="video.large"
                            className="mr-4 text-gray-600"
                            shouldInheritColor
                        />
                        Access video playlists on key features anytime
                    </Paragraph>
                </div>
                {finishing ? <FinishingButtons /> : <GetStartedButtons />}
            </div>
        </div>
    )
}
